import { REGISTER_SUBSCRIPTION } from './index';
import { Action } from '../action';
import { SubscriptionInfo } from '@shared/core';

export class RegisterSubscriptionInitAction implements Action {
	readonly type = REGISTER_SUBSCRIPTION.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class RegisterSubscriptionDestroyAction implements Action {
	readonly type = REGISTER_SUBSCRIPTION.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class RegisterSubscriptionClickSubmitAction implements Action {
	readonly type = REGISTER_SUBSCRIPTION.CLICK_SUBMIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class RegisterSubscriptionCreateAction implements Action {
	readonly type = REGISTER_SUBSCRIPTION.CREATE;
	constructor(
		public payload: SubscriptionInfo,
		public correlationId?: number
	) {}
}

export class RegisterSubscriptionCreateSuccessAction implements Action {
	readonly type = REGISTER_SUBSCRIPTION.CREATE_SUCCESS;
	constructor(
		public payload: SubscriptionInfo,
		public correlationId?: number
	) {}
}

export class RegisterSubscriptionCreateFailureAction implements Action {
	readonly type = REGISTER_SUBSCRIPTION.CREATE_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}

export class RegisterSubscriptionClickLogoutAction implements Action {
	readonly type = REGISTER_SUBSCRIPTION.CLICK_LOGOUT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class RegisterSubscriptionFormUpdateAction implements Action {
	readonly type = REGISTER_SUBSCRIPTION.FORM_UPDATE;
	constructor(
		public payload: SubscriptionInfo,
		public correlationId?: number
	) {}
}

export class RegisterSubscriptionFormResetAction implements Action {
	readonly type = REGISTER_SUBSCRIPTION.FORM_RESET;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}
